import React from "react";
import { useNavigate, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import LandingScreen from "../../pages/LandingScreen";
import Home from "../../pages/Home";
import PlayMaze from "../../pages/PlayMaze";
import Leaderboard from "../../pages/Leaderboard";
import Credits from "./Credits";

export default function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<LandingScreen />} />
        <Route path="/home" element={<Home />} />
        <Route path="/play" element={<PlayMaze />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/credits" element={<Credits />} />
      </Routes>
    </AnimatePresence>
  );
}
